import {numberWithCommas} from "./NumberWithCommas"


//format tiền tệ
export const formatCurrency = (value,type="usd") =>
    {
        switch(type){
            case "usd":
                return (`$${numberWithCommas(value)}`);  

            case "eur":
                return (`€${numberWithCommas(value)}`);  

            case "jpy":
                return (`¥${numberWithCommas(value)}`);  

            case "vnd":
                 return (`${numberWithCommas(value)} VND`);   
            default:
                  return value;
        }

       
    }



